<template>
    <section class="bg-ccu">
        <div class="container">
            <div class="v-h"></div>
            <!-- <div class="d-flex m-3 mt-4">
                <ion-icon name="camera-outline"></ion-icon>
                <h5 class="font-weight-bold text-dark mx-2">المصورين</h5>
            </div> -->
            <hr>
            <Moharam  v-if="$store.state.options.moharam" />
            <div class="row justify-content-center">
                
                <div class="col-lg-2 col-md-4 col-sm-3 col-xs-4 animate__animated animate__fadeIn p-2 d-flex justify-content-center" v-for="(photography,index) in members"
                    :key="index" :style="`animation-delay:.${index}s`">
                  <router-link :to="{name:'profile',params:{id:photography.id}}" class="text-center text-dark mt-2 h-6">
                <div class="card p-0">
                    <div class="card-image">
                        <img v-if="photography.avatar!=null"
                                        :src="`https://pic.imamhussain.org/avatars/large/${photography.avatar}`" alt="photography" width="50"  height="200"
                                        style="object-fit: cover;">
                                    <img v-else
                                        :src="`https://ui-avatars.com/api/?name=${photography.name}&length=1&bold=true&background=random`"  height="200"
                                        alt="photography" style="object-fit: cover;">
                    </div>
                    <div class="card-content d-flex flex-column align-items-center">
                      <h4>{{photography.name}}</h4>
                      <h5>{{photography.photos_count}} صورة</h5>
                        <ul class="social-icons d-flex justify-content-center" v-if="photography.about && photography.about.social != null">
                            <li style="--i:1" v-for="(social, name, index) in photography.about.social" :key="index" >
                                <a v-if="social !=''" :href="social" target="_blank">
                                    <span :class="`fab fa-${name}`"></span>
                                </a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
                <h5 class="mt-2">{{photography.name}}</h5>
                </router-link>  
            </div>
            </div>

        </div>
        <div class="container">
            <div class="row justify-content-center animate__animated animate__fadeInUp">

            <vs-button @click="loadMore" v-if="data.next_page_url !=null" color="rgb(211, 186, 127)" flat gradient :loading="loading" size="large">
                تحميل المزيد
            </vs-button>
        </div>
        </div>


    </section>
</template>
<script>
import Moharam from '../components/moharam.vue'
    export default {
        components:{Moharam},
        data() {
            return {
                data:JSON.parse(localStorage.getItem('photographers_data')) || [],
                members: [],
                page: 1,
                limit: 18,
                loading:false
            }
        },
        created() {
            this.fetchMembers()
        },
        methods: {
            fetchMembers() {
                this.loading=true;
                fetch(`https://pic.imamhussain.org/index.php/photographers?page=${this.page}&limit=${this.limit}`).then(res => res
                    .json()).then(res => {
                    this.data = res;
                    this.data.data.forEach(element => {
                       if (!this.members.includes(element)) {
                         this.members.push(element);  
                       }
                    }); 
                    localStorage.setItem('photographers_data',JSON.stringify(this.data))
                    this.loading=false;
                });
            },
            loadMore() {
                if (this.data.next_page_url != null) {
                    this.page++;
                    this.fetchMembers();
                }
            }
        },
        computed: {
            
        }
    }
</script>
<style lang="scss" scoped>
    .card {
    position: relative;
    padding: 0;
    margin: 0 !important;
    border-radius: 20px;
    overflow: hidden;
    max-width: 280px;
    max-height: 340px;
    cursor: pointer;
    border: none;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);

}

.card .card-image {
    width: 100%;
    max-height: 340px;
}

.card .card-image img {
    width: 100%;
    max-height: 340px;
    object-fit: cover;
}
.hover-t:hover {
    color: #fff !important;
}
.card .card-content {
    position: absolute;
    bottom: -180px;
    color: #fff;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(50px);
    min-height: 75px;
    width: 100%;
    transition: bottom .4s ease-in;
    box-shadow: 0 -10px 10px rgba(255, 255, 255, 0.1);
    
}

.card:hover .card-content {
    bottom: 0px;
}

.card:hover .card-content h4,
.card:hover .card-content h5 {
    transform: translateY(20px);
    opacity: 1;
}

.card .card-content h4,
.card .card-content h5 {
    font-size: 1.1rem;
    text-align: center;
    transition: 0.8s;
    font-weight: 500;
    opacity: 0;
    transform: translateY(-40px);
    transition-delay: 0.2s;
}

.card .card-content h5 {
    transition: 0.5s;
    font-weight: 200;
    font-size: 0.8rem;
    letter-spacing: 2px;
}

.card .card-content .social-icons {
    list-style: none;
    padding: 0;
}


.card .card-content .social-icons li {
    margin: 10px;
    transition: 0.5s;
    transition-delay: calc(0.15s * var(--i));
    transform: translateY(50px);
}


.card:hover .card-content .social-icons li {
    transform: translateY(20px);
}

.card .card-content .social-icons li a {
    color: #fff;
}

.card .card-content .social-icons li a span {
    font-size: 1.3rem;
}



</style>